import React, { useState, useRef } from 'react'
import { Spinner } from '../common/atoms';
import { Row, Col, Card } from 'antd';
import { Breadcrumb } from '../common/atoms';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Input } from 'antd';
import { companyMailerApi } from '../../services';
import Axios from 'axios'
import { handleAppError } from '../handlers';
import {successOrFailureToaster} from '../common/atoms/messages';
import { LaunchMailerModal, PopUpModals, TestMailModal, FailModal } from '../modals';
import { EMAIL_REGEX } from '../../constants/companyMailer';
import {edit_mail, preview_mail, launch_mailer, load_preview, phone_preview, 
  e_logo, logo_placeholder, upload_image, review_mailer, mile_stone, teaser_1_thumb,
  teaser_2_thumb, static_confetti, confetti, close_icon, close_copy, alert_icon } from '../../assets/images/index'

const { TextArea } = Input;

const MailSetup = (props) => {
    const inputRef = useRef('');
    const history = useHistory();
    const location = useLocation();
    const [pageloading, setPageLoading] = useState(false);
    const [sendModal, setSendModal] = useState({send: false, launch: false, launchSent: false, disable: false})
    const [image, setImage] = useState({active: false, url: ''})
    const [showData, setShowData] = useState({ 
      title: '', 
      data: {id: '',sender: '', subject: '', preview: '', company_logo: '', updated_at: '', mailer_type: '', content: ''}
    })
    const [test, setTest] = useState('');
    const [testMail, setTestMail] = useState(false)
    
    useEffect(() => {
      setPageLoading(true)
      getMailerContent(location.state.id)
    },[image.url])

    const getMailerContent = (id) => {
      const options = { id: id}
      companyMailerApi.show_mailer(
        options,
        (res) => {
          let subState = {
            title: location.state.title,
            data: res.data.mailer
          };
          setShowData((prev) => {
            return{...prev,...subState}
            })
          setPageLoading(false)
        },
        (err) => handleAppError(err)
      )
    }

    const changeHandler = e => {
      let subState = { ...showData.data,...{[e.target.name] : e.target.value}}
      setShowData( prevValues => {
      return { ...prevValues,...{data: subState}}
   })
   }

   const mail_sender = (event) => {
    setPageLoading(true);
    updateMailer(event);
    const options = {id: showData.data.id };
    companyMailerApi.mailer_sender(
      options,
      (res) => {
        if(res.data.message === "success"){
          if(showData.data.mailer_type !== 'launch'){
            let message = 'Congratulations! Your campaign was successfully created. Your campaign is queued to be sent.'
            successOrFailureToaster({ message, type: 'success'})
            history.push('/mailer')
          }
          setPageLoading(false);
        }else{
          successOrFailureToaster({message: 'Something when wrong! Try again', type: 'fail'})
        }
      },
      (err) => {
        if(err?.response?.data?.message === 'employee count is less than required'){
          let subState = {launch: false, launchSent: false, disable: true, send: false}
          setSendModal((prev) => {return {...prev, ...subState }})
        }else{
          handleAppError(err)
          successOrFailureToaster({message: 'Something when wrong! Try again', type: 'fail'})
        }
      }
    )
  }

    const updateMailer = (e) => {
      let type = e ? e.target.name: '';
      const options = { id: showData.data.id , data: showData.data}
      companyMailerApi.update_mailer(
        options,
        (res) => {
          if(type === 'save_quit'){
            if(res.data.msg === 'successfully saved' ){
              let message = 'Your campaign is successfully saved to the draft.'
              successOrFailureToaster({ message, type: 'success'})
              history.push('/mailer')
            }else{
              successOrFailureToaster({ message: 'Something when wrong! Try again', type: 'fail'})
            }
          }
        },
        (err) => handleAppError(err)
      )
    }

    const fieldValidation = (e) => {
      let event = e.target.name
      let valid = showData.data?.subject.length > 0 && showData.data?.sender.length > 0;
        if(valid && event === 'save_quit') {
          updateMailer(e);
        }else if (valid && event === 'testmail'){
          testMailFunc()
        }else if (valid && event === 'sendNow'){
          sendMailNowOrLater()
        }
        else{
          alert('Some fields are empty')
        }
    }

    const sendTest = (e) => {
      updateMailer(e);
      if(handleValidation(test)){
        test.split(',').map((mail) => {
          const options = { id: showData.data.id, data: {...showData.data, email: mail.trim()} }

          companyMailerApi.test_mail(
            options,
            (res) => {
              if(res.data.message === "success"){
                let message = `Test email sent successfully to: ${test.replace(',',', ')}`
                successOrFailureToaster({ message, type: 'success'})
                history.push('/mailer')
              }else{
                successOrFailureToaster({ message: 'Something when wrong! Try again', type: 'fail'})
              }
            },
            (err) => handleAppError(err)
          )
        })
        }else{
          alert('Not a valid email address.')
        }
    }

    const handleValidation = (email) => {
      let errors = {};
      let formIsValid = true
      email.split(',').map((mail) => {
      if (!mail.trim().match(EMAIL_REGEX)){
        errors["email"] = "Not a valid email"
        formIsValid = false
      }
      })
      return formIsValid
    }
    
    const edit_preview = (e) => {
      updateMailer(e)
      let show = false;
      if(e.target.name === 'preview'){
        show = true
      }
      history.push({
        pathname: '/mail-config',
        state: {id: showData.data.id,
                show: show}
      })
    }

    const sendMailNowOrLater = () => {
      let subState = {}
      if( showData.data.mailer_type === 'launch'){
        subState = {launch: !sendModal.launch}
      }else{
        subState = {send: !sendModal.send}
      }
      setSendModal((prev) => {
        return{...prev,...subState}
      });
    }

    const closeSendModal = () => {
      let subState = {launch: false, send: false}
      setSendModal((prev) => {
        return{...prev,...subState}
      })
  }

  const launchMailSent = () => {
    mail_sender()
    let subState = {launch: false, launchSent: true}
    setSendModal((prev) => {
      return{...prev,...subState}
    })
    sessionStorage.setItem('is_active', 'active');
  }

  const launchDone = () => {
    let subState = {launchSent: !sendModal.launchSent}
    setSendModal((prev) => {return{...prev,...subState}})
    history.push('/mailer')
    window.location.reload()
  }

    const onFileChange = (e) => {
      if(e.target && e.target.files[0]) {
        submitFileData(e.target.files[0])
      }
      
    }

    const submitFileData = (data) => {
      let companyId = sessionStorage.getItem('company_id');
      let id = showData.data.id
      let formData = new FormData();
      formData.append('file', data);
      Axios.post(
       window.API_URL + `corporate/companies/${companyId}/company_logo/${id}`,
        formData,
        {
          headers: {
            'X-EKINCARE-KEY': sessionStorage.getItem('axiosHeaders')
          }
        }
      )
      .then(res =>  {
        if(res.data.location){
          let subState = {active: true, url: res.data.location}
          setImage({...image,...subState});
        }
      })
      .catch(err => {
        console.log(err)
      })
    }

    const html_render = (height) => {
      return(
        <div class="container">
          <iframe srcdoc={document.createElement('div').innerHTML = showData?.data?.content || ''} width='100%' height={height} sandbox loading></iframe>
        </div>
      )
    }

    const getTime = (date) => {
      let DATE = new Date(date)
      let hrs = DATE.getHours();
      let min = DATE.getMinutes().toString();
      let ampm = (hrs < 12 || hrs === 24) ? 'AM' : 'PM';
      return( `${hrs%12 || 12 || ''}:${min.length == 1 ? 0+min : min || ''} ${ampm}` )
    }

    const testMailFunc = () => {
      setTestMail(!testMail);
    }

    const closeModal = () => {
      setSendModal((prev) => {return {...prev, disable: false}})
      window.location.reload()
    }

    const bottomStrip = () => {
      return(
        <div className='fixed bottom-0 bg-white flex flex-row justify-between -mx-6' style={{width: 'calc(100vw - 17rem)'}}>
          <div className='py-4 px-6'>
            <button name='save_quit' onClick={fieldValidation} className='text-blue-600 hover:bg-blue-50 transition text-base rounded-md font-semibold px-6 py-3'>Save</button>
          </div>
          <div className='bg-white py-4 px-7'>
            <button name='testmail' onClick = {fieldValidation} className='text-blue-600 bg-white hover:bg-blue-50 transition text-base font-semibold border-2 mx-4 rounded-md px-6 py-3'>Send test mail</button>
            <button name='sendNow' onClick ={fieldValidation} className='text-white text-base bg-blue-600 hover:bg-blue-500 transition font-semibold rounded-md px-6 py-3'>Send now</button>
          </div>
        </div>
      )
    }

  
    return(
      <Spinner visible={pageloading}>
        { testMail && 
            <TestMailModal title='Send a Test Email' description='Send a test to' onClose={testMailFunc} onSave={sendTest} inputVal={(val) => {setTest(val)}} />
          }
          { sendModal.send &&
            <PopUpModals 
              title={['Review ',showData.title]}
              description={["You are about to send the ",showData.title === 'teaser 1' ? <strong>first</strong> : <strong>second</strong>, <strong> teaser mail. </strong>,"It will help your employees know that something ", <strong>new</strong>, " and ",<strong>big</strong>," is coming"]}
              onCancel='Send it later'
              onPass='Send now'
              icon={review_mailer}
              onClose={closeSendModal}
              onSave={mail_sender}
            />
          }
           { sendModal.launch &&
            <LaunchMailerModal 
              title='Congratulations!'
              description={"Your workplace is going to take a big step toward becoming a healthier place in no time"}
              onPass='Launch now'
              launch={true}
              onClose={closeSendModal}
              onSave={launchMailSent}
              confetti={static_confetti}
              close_icon={close_copy}
            />
          }
          { sendModal.launchSent &&
            <LaunchMailerModal 
              title='Congratulations!'
              description={["On taking steps to keep your employees healthy. ",
              <span className='text-blue-600 font-bold'><br/>{location.state.count} employees</span>,
              " in your company now have access to",<strong> health<br/> benefits via ekincare</strong>]}
              icon={mile_stone}
              onClose={launchDone}
              confetti={confetti}
              close_icon={close_icon}
            />
          }
          <FailModal
            visible={sendModal.disable}
            title='Missing employee list'
            description='Mails cannot be sent because employees are not added.'
            btntext='Okay'
            close={closeModal}
            btnhandler={closeModal}
            missing={true}
          />
          <div className=''>
              <Breadcrumb list={[{text: 'Pre Launch', link: '/mailer'},{text: 'Design Teaser',link: '#'}]}/>
              <Card style={{ borderRadius: '8px', marginTop: 20 ,marginBottom: '75px' }} loading={pageloading} className=''>
                  <Row className='font-semibold text-lg capitalize'>{showData.title}</Row>
                  <Row style={{ fontWeight: 400, width: 699, marginTop: 7}}>
                      Teaser is a short e-mail that creates a buzz among employees about the new benefit they would be receiving.
                      You can modify the subject line, preview text, sender name and the email content if require.
                  </Row>
                  <Row>
                    <Col span={8}>
                    <Row className='font-semibold text-sm mt-8'>FROM</Row>
                    <Row className='font-normal mt-2 text-base'>noreply@ekincare.com</Row>
                    <Row className='font-semibold text-sm mt-8'>SENDER NAME</Row>
                    <Row className='font-normal mt-1.5' style={{color: '#8895AF'}}>Enter a name (e.g. your company name) to help campaign recipients recognize you in their inbox.</Row>
                    <Row className='my-3'>
                      <input 
                        name='sender' 
                        value={showData.data?.sender} 
                        className='font-semibold border-2 rounded-md px-3 text-base focus:outline-none' 
                        style={{ width: '90%', minHeight: 48, color:'#324467', background: '#F5F7F9', borderColor: `${showData.data?.sender.length <= 0 ? '#D74651' : '#E5E8F0'}`}} 
                        onChange={changeHandler} 
                      />
                      {showData.data?.sender.length <= 0 ? 
                      <div style={{color: '#D74651'}} className='flex justify-start mt-1'>
                        <img src={alert_icon} className='px-1.5'/>
                        <div className='mt-0.5 text-xs'>Please enter sender name</div>
                      </div> : ''}
                    </Row>
                    <Row className='font-semibold text-sm mt-8 pr-12'>
                      <div className='flex justify-between'>
                        <div>SUBJECT</div>
                        <div className='font-normal' style={{color: '#A4B0CC'}}>150 words</div>
                      </div>
                    </Row>
                    <Row className='font-normal mt-1.5' style={{color: '#8895AF'}}>Write a subject line that clearly describes your email content.</Row>
                    <Row className='my-3'>
                      <input 
                        name='subject' 
                        value={showData.data?.subject} 
                        className='font-semibold border-2 rounded-md px-3 bg-zinc-100 text-stone-900 text-base focus:outline-none' 
                        style={{ width: '90%', minHeight: 48, color:'#324467', background: '#F5F7F9', borderColor: `${showData.data?.subject.length <= 0 ? '#D74651' : '#E5E8F0'}`}} 
                        onChange={changeHandler} 
                      />
                      {showData.data?.subject.length <= 0 ? 
                      <div style={{color: '#D74651'}} className='flex justify-start mt-1'>
                        <img src={alert_icon} className='px-1.5'/>
                        <div className='mt-0.5 text-xs'>Please enter subject</div>
                      </div> : ''}
                    </Row>
                    <Row className='font-semibold text-sm mt-8 pr-12'>
                      <div className='flex justify-between'>
                        <div>PREVIEW TEXT</div>
                        <div className='font-normal' style={{color: '#A4B0CC'}}>150 words</div>
                      </div>
                    </Row>
                    <Row className='font-normal mt-1.5' style={{color: '#8895AF'}}>Write a short text that gives an overview of the content of your email.</Row>
                    <Row className='my-3'>
                      <TextArea name='preview' value={showData.data?.preview} className='font-semibold' placeholder='' style={{padding: '16px', fontSize: '16px', width: '90%', color:'#324467', borderRadius: '6px', border: 'none', borderWidth: '2px'}} onChange={changeHandler} autoSize={{ minRows: 2, maxRows: 6 }}/>
                    </Row>
                    </Col>
                    <Col span={1} className='m-4'/>
                    <Col span={9}>
                    <Row className='relative' style={{backgroundImage: `url(${phone_preview})`, width: 486, marginTop: 30,
                                minHeight: 500,
                                backgroundRepeat: 'no-repeat'}}>
                      <div className='absolute top-20 left-11 flex justify-between mt-9'>
                        <div className='m-2 py-3'><img src={e_logo} style={{width: '46px', height: '46px'}}/></div>
                        <div className='m-2 font-semibold text-lg py-2' style={{color: '#243352'}}>
                          <div className='flex justify-between' style={{width: 324}}>
                            <div>{(showData.data?.sender).length < 26 ? `${showData.data?.sender}` : `${showData.data?.sender.substring(0,26)}...`}</div>
                            <div className='font-normal text-sm'>{getTime(showData.data.updated_at)}</div>
                          </div>
                          <div>{(showData.data?.subject).length < 31 ? `${showData.data?.subject}` : `${showData.data?.subject.substring(0,31)}...` }</div>
                          <div className='font-normal text-sm' style={{width: 280, color: '#4D6189'}}>
                            {(showData.data?.preview).length < 86 ? `${showData.data?.preview}` : `${showData.data?.preview.substring(0,86)}...` }
                          </div>
                        </div>
                      </div>
                    </Row>
                    </Col>
                  </Row>
                  { showData.title === 'teaser 1' ? '' :
                  <Row className='mt-8'>
                    <div className='font-semibold text-sm '>COMPANY LOGO</div>
                    <div className='font-normal text-xs rounded-lg my-2 p-2 pl-4 border' style={{background: '#F5F7F9', width: '75%'}}>
                         <div className='flex flex-row'>
                          <div className='bg-white w-56 my-2 rounded-md text-center' style={{maxHeight: '170px'}}>
                            <input ref={(fileInput) => (inputRef.current = fileInput)} style={{display: 'none'}} type='file' accept='image/*' id='myFile' name='file' className='h-16 w-48' onChange={onFileChange}/>
                            <img src={ showData.data?.company_logo ? showData.data.company_logo : logo_placeholder } style={{ maxHeight: '140px'}} className='p-2 block mx-auto align-middle'/>
                          </div>
                          <div className='ml-4 block my-auto'>
                              <button onClick={() => inputRef.current?.click()} className='text-xs font-semibold h-9 w-32 bg-white border-2 rounded-lg px-1 py-2 my-2 hover:bg-blue-50 transition flex flex-row'>
                                <img src={showData.data?.company_logo ? load_preview : upload_image} alt='#' className='mx-2'/>
                                <div className='py-0.5' style={{color: '#0951E1'}}>{ showData.data?.company_logo ? 'Replace Logo' : 'Upload Logo'}</div>
                              </button>
                            <p className='text-xs font-normal'>Image should be 300x80px. <br/>
                            SVG or transparent PNG recommended. GIF. JPG also supported.</p>
                          </div>
                        </div>
                    </div>
                  </Row> }
                  <Row className='font-semibold text-sm my-4'>
                    <Col span={6}>DESIGN</Col>
                  </Row>
                  <Row style={{ fontWeight: 400, width: 699, marginTop: 7}}>
                  Personalize the mailer experience by reviewing and updating it
                  </Row>
                  <Row>
                      <Col>
                        <div className='px-3 py-3'>
                          <div className='border-2 rounded-lg relative w-1/3' style={{ minHeight: 260}}>
                            <div className='absoulte z-10 flex justify-end'>
                              <div className={`border rounded-md w-full p-2 bg-gray-100 ${showData.title === 'official launch' ? 'p-2' : ''}`}>
                                {html_render('370')}
                              </div> 
                            </div>
                          </div>
                          <div className='flex items-center my-3'>
                            <button onClick ={edit_preview} name='edit' className='text-blue-600 text-sm font-semibold border-2 rounded-lg px-4 py-2 flex flex-row hover:bg-blue-50 transition'>
                              <img src={edit_mail} alt='edit' className='px-1 py-0.5'/>Edit
                            </button>
                            <button onClick ={edit_preview} name='preview' className='text-blue-600 text-sm font-semibold border-2 mx-3 rounded-lg px-4 py-2 flex flex-row hover:bg-blue-50 transition'>
                              <img src={preview_mail} alt='preview' className='px-1 py-0.5' />Preview
                              </button>
                            </div>
                        </div>
                      </Col>
                  </Row>
              </Card>
              {bottomStrip()}
          </div>
      </Spinner>
  )

}

export default MailSetup;